import { wa } from 'apps/analytics';

export function reportCheckoutButtonClicked(origin = 'UNKNOWN', redirect) {
  wa.triggerPageEventWithDescription(
    'Checkout button clicked',
    {
      BUTTON_LOC: origin,
    },
    redirect
  );
}
